import React from 'react';
import { UploadDropZone, UploadsButton } from '@design-stack-vista/upload-components';

export const SherbertUploader = () => {
  return (
    <UploadDropZone noClick={true} noKeyboard={true}>
      <UploadsButton>Upload from sherbert</UploadsButton>
    </UploadDropZone>
  );
};
